/* Progressive enhancement only. Shopify owns variants, prices, forms and cart. */
(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-sm-buy-jump]');
    if (!link) return;
    const target = document.querySelector('product-info .product-form__input') || document.querySelector('product-info .product-form__buttons');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    const control = target.querySelector('input:checked, select, button');
    if (control) control.focus({preventScroll: true});
  });
  const init = () => {
    const buy = document.querySelector('product-info .product-form__buttons');
    const jump = document.querySelector('[data-sm-buy-jump]');
    if (!buy || !jump) return;
    jump.href = '#' + buy.closest('product-info').id;
    if (buy.dataset.smwordObserved === 'true') return;
    buy.dataset.smwordObserved = 'true';
    let scheduled = false;
    const update = () => {
      scheduled = false;
      const visible = buy.getBoundingClientRect().bottom < 0;
      jump.classList.toggle('is-visible', visible);
      jump.inert = !visible;
    };
    const schedule = () => {
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(update);
      }
    };
    // A direct anchor jump can skip both intersection boundaries.
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    window.addEventListener('pageshow', schedule);
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
